/*
 * @FilePath: /mall-fe/src/libs/contexts/index.ts
 * @Description: 全局级别上下文信息定义文件
 *
 */
import { noop } from 'libs/utils';
import { createContext } from 'react';
import { OrigItemPrices } from 'libs/trade-repo';

export const UserContext = createContext<UserInfo>(undefined);
UserContext.displayName = 'UserContext';

// 移动端结算,支付,枚举字典
export const ProcureEnumDictionaryContext = createContext<Record<string, any>>({});
ProcureEnumDictionaryContext.displayName = 'ProcureEnumDictionaryContext';

// 设备信息，是否移动端
export const MediaQueryContext = createContext<MediaQueryContextInterface>(null);
MediaQueryContext.displayName = 'MediaQueryContext';

// 运营配置信息
export const ConfigurationContext = createContext<Array<any>>([]);
ConfigurationContext.displayName = 'ConfigurationContext';

// oss等配置信息
export const RuntimeConfigurationContext = createContext<Array<any>>([]);
RuntimeConfigurationContext.displayName = 'RuntimeConfigurationContext';

// 商城首页导航配置信息
export const NavConfigContext = createContext<NavConfigInterface>(null);
NavConfigContext.displayName = 'NavContext';

export interface ModalContextInterface {
  onModal: boolean;
  width?: string;
}
export const ModalContext = createContext<ModalContextInterface>({
  onModal: false,
});
ModalContext.displayName = 'ModalContext';

// TODO maybe no partial
export const SiteContext = createContext<Partial<SiteConfig>>(null);
SiteContext.displayName = 'SiteContext';

/**
 * 由于服务端渲染不能在服务端拿到设备信息
 * 加一个context用于存设备信息，比如userAgent
 */
export const DeviceContext = createContext<DeviceContextInterface>(null);
DeviceContext.displayName = 'DeviceContext';

export const CartContext = createContext<CartContextInterface>({
  cartData: undefined, // 购物车完整数据
  skuList: [], // minCart展示
  cartList: [], // 购物车list
  quantity: 0, // 统计数量
  totalAmount: 0, // 统计总金额
  refetchCart: noop, // 获取购物车信息
  resetCartList: noop, //setCartList()
  addCart: noop, // 添加购物车
  updateCart: noop, // 更新购物车商品数量
  removeCart: noop, // 移除购物车商品
  loading: true, // loading 状态
  refreshData: noop,
  refreshSelected: noop,
});
CartContext.displayName = 'CartContext';

// 高级店铺首页、商品列表中的分类信息
export const CategoryContext = createContext<Array<any>>([]);
CategoryContext.displayName = 'CategoryContext';

// 地址地区信息
export const LocContext = createContext<LocContextValue>({
  location: { sysNo: '', areaCode: '' },
  locKey: '',
  setLocation: noop,
});
LocContext.displayName = 'LocContext';

export const OrderContext = createContext<OrderContextInterface>({
  order: {},
  setOrder: () => {},
  tradeList: [], // 收银台交易信息
  setTradeList: noop, // 设置收银台交易信息
  clearTradeList: noop, // 移除收银台交易信息
});
OrderContext.displayName = 'OrderContext';

/**
 * 金额显示逻辑
 */
export const PriceContext = createContext<PriceContextValue>({
  showPrice: true,
  tip: '',
  shopPriceFlag: null,
  showSellCount: false,
  showScore: false,
});
LocContext.displayName = 'LocContext';

/**
 * 订单页面，所有弹窗都在根 comp 上，操作用 context 传下去了
 */
export const TradeContext = createContext({
  showFlowPicker: () => {},
  showFlowViewer: () => {},
  showSupplierConfirm: () => {},
  showCompleteDialog: () => {},
  showSupplierDeny: () => {},
  showSupplierPayDone: () => {},
  canCancel: false,
  form: null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateEnity: (entity) => {},
  origPrices: {} as OrigItemPrices,
  showCancelConfirm: () => {},
});

export {
  ProductListNetPriceContextProvider,
  useProductListNetPriceContext,
  useNetActionPriceContext,
} from './ProductListNetPrice';
